<template>
  <div class="sign-up-list-phone">
    <div class="top">
      <img src="../../assets/img/img-sing-up-top-phone.png" class="img-sing-up-top-phone" alt="">
      <span class="btn-add-sign-up-top" :class="{'android' : isAndroids }">我要报名</span>
    </div>
    <div class="main" :class="{'android' : isAndroids }">
      <div class="content">
        <div class="title">
          <img src="../../assets/img/img-yaoqinghang.png" class="img-yaoqinghan" alt="">
        </div>
        <div class="text">
          <p style="text-indent: 0">全国各高中学校：</p>
          <p>为帮助各高中学校检验本校高三复习效果，帮助学生找到复习中存在的问题，满足全国师生在备考时各项需求，
            达到错因精准定位，排名精准评估，成绩精准提升的目的，风向标教育联合全国千余所高级中学，开展本次<span class="red">全学科、高保真</span>的高三联合质量评估考试。</p>
          <p>通过本次联合质量评估，学校可以清晰掌握本校复习各项指标，梳理各班、各层次学生的复习情况，为接下来的复习定标准、找方向。利用风向标智能精准教学系统，为每一所学校提供专项报告、每一名教师提供专属教案，每一位学生提供个性化提升方案。
            为了实现教师精准备考、学生个性化复习，风向标教育联合高考命题专家，举办线上联合评估质量分析会议，进一步明确复习亮点和不足，打造行之有效的精准复习备考策略。</p>
          <p class="text-title">一、报名方式</p>
          <p>知心慧学项目学校通过学管登录学管端进行考试报名；（学校告知在校学管报名）</p>
          <p>其他学校可以通过知心慧学官网提交报名信息，或者通过业务经理进行报名。</p>
          <p>采用邮箱报名：zhao@fxbjy.com</p>
          <p class="text-title">二、组织考试</p>
          <p>考试时间：2019年12月19日-20日（具体科目时间安排见下表）</p>
          <table class="table-sing-up" border="1">
            <tr class="table-head">
              <td colspan="4">考试时间安排</td>
            </tr>
            <tr>
              <td width="0.34rem">适用范围</td>
              <td>时间</td>
              <td>上午</td>
              <td>下午</td>
            </tr>
            <tr>
              <td>全国</td>
              <td>12月19日</td>
              <td>语文  <br />09:00-11:30</td>
              <td>数学（文理）<br />  15:00-17:00</td>
            </tr>
            <tr>
              <td>全国</td>
              <td>12月20日</td>
              <td>文科综合<br />理科综合 <br /> 09:00-11:30</td>
              <td>英语 <br /> 15:00-17:00</td>
            </tr>
          </table>
          <p>为保证本次联合质量评估的公平、公正，参评学校名称在系统内均以<span class="red">特定代码的方式</span>呈现。系统<span class="red">提前2小时</span>发布试卷，由学管（或学校相关人员）按时下载并打印试卷、答题卡。</p>
          <p>考试结束后学管（或学校相关人员）扫描答题卡。</p>
          <p>参考学校的老师，在12月21日12点前完成所有线上阅卷（阅卷规则和时间<span class="red">详见附件1</span>）。</p>
          <p class="text-title">三、成绩报告</p>
          <p>2019年12月23日-24日，老师可以登录风向标智能精准教学系统（知心慧学）在线查看本校成绩报告，也可以在线查看本省整体综合报告。</p>
          <p class="text-title">四、联合质量分析会议</p>
          <p>2019年12月26日及27日举办线上质量分析会议，帮助学校进一步精准找到原因，明确本次联评存在的问题，结合今年高考预测，共同打造高效的二轮精准备考方案。（具体科目时间安排见下表）</p>
          <table class="table-sing-up" border="1">
            <tr class="table-head">
              <td colspan="4">线上质量分析会议时间安排</td>
            </tr>
            <tr>
              <td width="0.34rem">适用范围</td>
              <td>时间</td>
              <td>上午</td>
              <td>下午</td>
            </tr>
            <tr>
              <td>全国</td>
              <td>12月26日</td>
              <td>语文  <br />09:00-11:30</td>
              <td>数学（文理）<br />  15:00-17:00</td>
            </tr>
            <tr>
              <td>全国</td>
              <td>12月27日</td>
              <td>文科综合 <br />理科综合 <br /> 09:00-11:30</td>
              <td>英语  <br /> 15:00-17:00</td>
            </tr>
          </table>
          <p style="text-indent: 0">阅卷规则详见<span class="red">附件1</span>。</p>
          <p style="text-indent: 0">考试的各科考察范围及命卷细目详情见<span class="red">附件2</span>。</p>
          <p>诚挚邀请！</p>
          <div class="corporate-name">
            <img src="../../assets/img/img-seal.png" alt="" class="seal">
            <div class="name">
              <p>江西风向标教育科技有限公司</p>
              <p>2019年12月3日</p>
            </div>
          </div>
          <div class="down">
            <p>附件1:
              <a href="/static/lk-yj.PNG" target="_blank">教师线上阅卷规则说明(点击预览)</a>
            </p>
            <p>附件2:
              <a href="/static/lk-km.PNG" target="_blank">命卷细目表及各科考试安排(点击预览)</a>
            </p>
          </div>

        </div>
        <span class="btn-sing-up" @click="isStop = true">我要报名<img v-if="isStop" src="../../assets/img/img-stop.png" class="img-stop" alt=""></span>

      </div>
    </div>
    <el-dialog title="填写报名资料" :visible.sync="signUpData" width="90%">
      <div class="sign-up-data">
        <div class="row">
            <span class="left">学校
              <span class="red">*</span>
            </span>
          <el-input v-model="school_name" placeholder="请输入内容"></el-input>
        </div>
        <div class="row">
            <span class="left">姓名
              <span class="red">*</span>
            </span>
          <el-input v-model="userName" placeholder="请输入内容"></el-input>
        </div>
        <div class="row">
            <span class="left">手机
              <span class="red">*</span>
            </span><el-input v-model="mobile" placeholder="请输入内容" minlength="6" maxlength="11"></el-input>
        </div>
        <div class="row">
            <span class="left" style="vertical-align: top;">考试科目
            <span class="red">*</span>
            </span>
          <span class="subject-box subject-checkbox-box">
              <el-checkbox-group v-model="subject">
                <el-checkbox label="语文"></el-checkbox>
                <el-checkbox label="数学(文)"></el-checkbox>
                <el-checkbox label="数学(理)"></el-checkbox>
                <el-checkbox label="英语"></el-checkbox>
                <el-checkbox label="文科综合"></el-checkbox>
                <el-checkbox label="理科综合"></el-checkbox>
              </el-checkbox-group>
            </span>

        </div>
        <div>
          <p class="red">注：不参加联考的科目请自行取消勾选</p>
        </div>
        <div style="text-align: center;">
          <span class="btn-add-sing-up" @click="save">提交</span>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="提交成功" :visible.sync="signUpSuccess" width="760px">
      <div class="sign-up-success">
        <img src="../../assets/img/img-save-success.png" alt="">
        <div class="msg-box">
          <p class="big-msg">恭喜你！提交成功</p>
          <p class="msg">我们的工作人员将会及时联系您，并妥善保管您的相关信息！</p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "signUpListPhone",
    data() {
      return {
        signUpData:false,
        subject:['语文','英语','数学(文)','文科综合','数学(理)','理科综合'],
        school_name:'',
        mobile:'',
        userName:'',
        signUpSuccess:false,
        isStop:false,
        HtmlFontSize:'',
        isAndroids:false,
      }
    },
    created() {
      this.showAndroid();
    },
    mounted(){
      window.addEventListener("resize",this.setHtmlFontSize);
      let _this = this;
      setTimeout(function(){
        _this.getFontSize();
      }, 500);
    },
    beforeDestroy(){
      window.removeEventListener("resize",this.setHtmlFontSize)
    },
    methods: {
      showAndroid(){
        let u = navigator.userAgent;
        this.isAndroids = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
      },
      getFontSize(){
        let htmlEl = document.getElementsByTagName('html')[0];
        this.HtmlFontSize = htmlEl.style.fontSize;
      },
      setHtmlFontSize(){
        let u = navigator.userAgent;
        let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
        if(isAndroid){
          return false
        }

        if(this.HtmlFontSize==''){
          return false
        }
        let _this = this;
        let htmlEl = document.getElementsByTagName('html')[0];
        setTimeout(function(){
          htmlEl.style.fontSize = _this.HtmlFontSize;
        }, 301);
      },
      AndroidHtmlFontSize(){
        this.HtmlFontSize = '36px';
        let _this = this;
        let htmlEl = document.getElementsByTagName('html')[0];
        let setHtmlFontSize = setInterval(function(){
          htmlEl.style.fontSize = _this.HtmlFontSize;
        },1);
        setTimeout(function(){
          clearInterval(setHtmlFontSize);
        }, 310);
      },
      save(){
        let _this = this;
        let data ={
          subjects:'',
          school_name:this.school_name,
          mobile:this.mobile,
          userName:this.userName,
        }
        this.subject.forEach(i=>{
          data.subjects = data.subjects+i+','
        })

        if(this.school_name==''){
          this.$message.error('请填写学校名称');
          this.mobile = '';
          return false
        }
        if(this.userName==''){
          this.$message.error('请填写姓名');
          this.mobile = '';
          return false
        }
        if(!this.isPhoneNum(this.mobile)){
          this.$message.error('请填写正确的手机号码');
          this.mobile = '';
          return false
        }
        if(data.subjects==''){
          this.$message.error('请选择科目');
          this.mobile = '';
          return false
        }
        Http.Axios.post(`${Http.SIGN_UP_API_ROOT()}/rest/official_enroll/joint_sign`,data).then(function (res) {
          _this.signUpData = false;
          _this.signUpSuccess = true
        }).catch(function (err) {
          _this.$message.error('提交失败');
        });

      },
      isPhoneNum(str) {
        return /^(0|86|17951)?(13[0-9]|15[012356789]|16[0-9]|17[678]|18[0-9]|19[0-9]|14[57])[0-9]{8}$/.test(str)
      },
    },
  }
</script>

<style scoped lang="less">

  .img-yaoqinghan{
    width: 2.4rem;
  }
  .red{
    color: #ff3600;
  }
  .sign-up-list-phone{
    position: relative;
    .img-sing-up-top-phone{
      width: 100%;
    }
    .main{
      .content{
        padding: 0 0.45rem;
        .title{
          margin-top: 0.49rem;
          text-align: center;
        }
        .text{
          font-size: 0.48rem;
          color: #393939;
          line-height: 1.5em;
          p{
            text-indent: 2em;
          }
          .text-title{
            font-weight: bold;
            text-indent: 0;
          }
        }
        .table-sing-up{
          margin-top: 0.13rem;
          margin-bottom: 0.13rem;
          /*margin-left: 28px;*/
          width: 100%;
          text-align: center;
          border-color:#afccfa;
          .table-head{
            line-height: 0.53rem;
            font-weight: bold;
            background-color: #afccfa;
            color: #5476db;
          }
          td{
            padding: 0.1rem 0.027rem;
            font-size: 0.48rem;
            line-height: 1.5em;
          }
        }
        .corporate-name{
          position: relative;
          text-align: right;
          .seal{
            width: 3.4rem;
          }
          p{
            text-align: right;
          }
          .name{
            position: absolute;
            right: 0;
            top:0.56rem;
          }
        }
        .down{
          color: #3c45fe;
          z-index: 1998;
          a{
            color: #3c45fe;
            text-decoration:underline;
          }
          p{
            text-indent: 0;
          }
        }
        .btn-sing-up{
          position: relative;
          display: inline-block;
          left: 50%;
          margin-top: 1rem;
          margin-left: -1.93rem;
          margin-bottom: 0.346rem;
          width: 3.88rem;
          height: 0.8rem;
          line-height: 0.8rem;
          text-align: center;
          color: #fff;
          font-size: 0.48rem;
          font-weight: bold;
          background: #cccccc;
          border-radius: 0.4rem;
          cursor: not-allowed;
          z-index: 1999;
          .img-stop{
            width: 0.427rem;
            position: absolute;
            top: 0.16rem;
            right: 0.2rem;
          }
        }

      }

    }
    .sign-up-data{
      .row{
        margin-top: 0.173rem;
        margin-bottom: 0.173rem;
        .left{

        }
        .subject-box{
        }
        .subject-checkbox-box{
          display: inline-block;
          margin-top: 0.2rem;
        }
      }
      .btn-add-sing-up{
        margin-top: 0.2rem;
        position: relative;
        display: inline-block;
        width: 2.77rem;
        height: 0.57rem;
        line-height: 0.57rem;
        text-align: center;
        color: #fff;
        font-size: 0.48rem;
        font-weight: bold;
        background:url("../../assets/img/bg-btn-add-sing-up.png");
        cursor: pointer;
      }

    }
    .sign-up-success{
      text-align: center;
      .msg-box{
        display: inline-block;
        vertical-align: top;
        margin-top: 0.13rem;
        margin-left: 0.266rem;
        .big-msg{
          font-size: 0.37rem;
          font-weight: bold;
          color: #000;
          text-align: left;
        }
        .msg{
          margin-top: 0.13rem;
          font-size: 0.187rem;
          font-weight: bold;
          color: #a9a9a9;
          text-align: left;
        }
      }
    }
    .btn-add{
      cursor: not-allowed;
    }
  }
  .btn-add-sign-up-top{
    display: inline-block;
    position: absolute;
    top: 0.2rem;
    right: 0.2rem;
    padding: 0.027rem 0.2rem;
    font-weight: bold;
    color: #cf08e7;
    background-color: #fff;
    border-radius: 0.133rem;
    cursor: pointer;
  }
  .btn-add-sign-up-top.android{
    top: 15px* 0.48;
    right: 15px* 0.48;
    padding: 1px 15px* 0.48;
    border-radius: 10px* 0.48;
  }
  .main.android{
    .content{
      padding: 0 34px * 0.48;
      .title{
        margin-top: 37px * 0.48;
        text-align: center;
        .img-yaoqinghan{
          width: 180px* 0.48;
        }
      }
      .text{
        font-size: 36px * 0.48;
        color: #393939;
        line-height: 46px * 0.48;
        p{
          text-indent: 2em;
        }
        .text-title{
          font-weight: bold;
          text-indent: 0;
        }
      }
      .table-sing-up{
        margin-top: 10px* 0.48;
        margin-bottom:10px* 0.48;
        /*margin-left: 28px;*/
        width: 100%;
        text-align: center;
        border-color:#afccfa;
        .table-head{
          line-height: 46px* 0.48;
          font-weight: bold;
          background-color: #afccfa;
          color: #5476db;
        }
        td{
          padding: 8px* 0.48 2px* 0.48;
          font-size: 36px* 0.48;
          line-height: 46px* 0.48;
        }
      }
      .corporate-name{
        position: relative;
        text-align: right;
        .seal{
          width: 255px* 0.48;
        }
        p{
          text-align: right;
        }
        .name{
          position: absolute;
          right: 0;
          top:80px* 0.48;
        }
      }
      .down{
        color: #3c45fe;
        z-index: 1998;
        a{
          color: #3c45fe;
          text-decoration:underline;
        }
        p{
          text-indent: 0;
        }
      }
      .btn-sing-up{
        position: relative;
        display: inline-block;
        left: 50%;
        margin-top: 10px * 0.48;
        margin-left: -145px * 0.48;
        margin-bottom: 26px * 0.48;
        width: 291px* 0.48;
        height: 60px* 0.48;
        line-height: 60px* 0.48;
        text-align: center;
        color: #fff;
        font-size: 36px * 0.48;
        font-weight: bold;
        background: #cccccc;
        border-radius: 30px* 0.48;
        cursor: not-allowed;
        z-index: 1999;
        .img-stop{
          width: 36px * 0.48;
          position: absolute;
          top: 12px* 0.48;
          right: 15px* 0.48;
        }
      }

    }
  }
</style>

<style>
  .sign-up-data .el-checkbox{
    width: 0.64rem;
    margin-bottom: 0.15rem;
  }
</style>



// WEBPACK FOOTER //
// signUpListPhone.vue?630e9214